import service from '../service.js';

export function userLogin(params){
    return service({
        url: '/user/login',
        method: 'post',
        data: params
    })
}
export function userRegister(params){
    return service({
        url: '/user/register',
        method: 'post',
        data: params
    })
}
export function userCompanyReg(params){
    return service({
        url: '/user/company_reg',
        method: 'post',
        data: params
    })
}

export function userCompanyUpdate(params){
    return service({
        url: '/user/company_update',
        method: 'post',
        data: params
    })
}

export function userLogout(params){
    return service({
        url: '/user/logout',
        method: 'post',
        data: params
    })
}


export function uploadImg(params,fn){
    return service({
        url: '/upload/img',
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: fn
    })
}


export function projectList(params){
    return service({
        url: '/index/project',
        method: 'get',
        params: params
    })
}

export function projectView(params){
    return service({
        url: '/index/project_view',
        method: 'get',
        params: params
    })
}


export function userInfo(params){
    return service({
        url: '/user/info',
        method: 'get',
        params: params
    })
}
export function indexBanner(params){
    return service({
        url: '/index/banner',
        method: 'get',
        params: params
    })
}

export function indexVotedo(params){
    return service({
        url: '/index/votedo',
        method: 'post',
        data: params
    })
}